<script setup lang="ts">
import { computed } from "vue";
import BaseHeader from "@/components/Header/BaseHeader.vue";
import DesktopSideBar from "@/components/Sidebar/DesktopSideBar.vue";
import MobileSideBar from "@/components/Sidebar/MobileSideBar.vue";
import type { LayoutProps } from "./types";

const props = withDefaults(defineProps<LayoutProps>(), {
  ldClient: "",
  logoUrl: "",
  logoUrlSquare: "",
});

const sidebarClass = computed<string>(() => {
  if (!props.isLoggedIn) {
    return "";
  }
  return "md:grid md:grid-cols-sidebar-main md:flex md:flex-grow";
});
</script>

<template>
  <base-header :ld-client="props.ldClient" :logo="props.logoUrl" />

  <div class="w-full mx-auto h-full md:flex md:flex-col">
    <mobile-side-bar v-if="props.isLoggedIn" :logo="props.logoUrl" />
    <main :class="sidebarClass">
      <desktop-side-bar v-if="props.isLoggedIn" />
      <slot />
    </main>
  </div>
</template>

